import React from "react";
import styles from "./social-icons.module.scss";
import { FaGithub, FaTwitter } from "react-icons/fa";
import Link from "next/link";
import { FaXTwitter } from "react-icons/fa6";
import { LINKS } from "@/constants/links.constant";

type Props = {};

const SocialIcons = (props: Props) => {
  return (
    <ul className={styles.socialIcons}>
      <li>
        <Link href={LINKS.SOCIAL.X} target="_blank">
          <FaXTwitter size={30} />
        </Link>
      </li>
      <li>
        <Link href={LINKS.SOCIAL.GITHUB} target="_blank">
          <FaGithub size={30} />
        </Link>
      </li>
    </ul>
  );
};

export default SocialIcons;
